module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0113.jpg?v=a267c9fa";